module.exports = __webpack_public_path__ + "static/media/car_dealer.f451e7fa.jpg";